import CustomizeRulesForm from '$components/Services/ReceivedRequests/CustomizeRulesForm'
import { Col, Row, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import Form from '$components/Form'
import CustomInputNumber from '$components/CustomInputNumber'

const { Text } = Typography

const ProviderOfferForm = ({
  orderPartId,
  providerOffer,
  resetInvalidProviderOffers,
  deleteRule,
}) => {
  const { t } = useTranslation()
  const form = Form.useFormInstance()

  const amount = Form.useWatch(
    [orderPartId, 'provider_offers', providerOffer.offer_id, 'amount'],
    form,
  )
  const basePrice = Form.useWatch(
    [orderPartId, 'provider_offers', providerOffer.offer_id, 'base_price'],
    form,
  )

  const calculateRebate = () => {
    const allOffers = form.getFieldValue([orderPartId, 'provider_offers'])
    if (!basePrice || !allOffers) return null

    const offersArray = Object.entries(allOffers).map(([id, offer]) => ({
      ...offer,
      offer_id: id,
    }))

    const baselineOffer = offersArray.reduce((min, offer) => {
      if (!offer.amount) return min
      if (!min.amount || offer.amount < min.amount) return offer
      return min
    }, {})

    if (
      !baselineOffer.offer_id ||
      baselineOffer.offer_id === providerOffer.offer_id
    ) {
      return null
    }

    const baselinePrice = baselineOffer.base_price

    if (!baselinePrice || !basePrice) return null

    const rebatePercent = ((baselinePrice - basePrice) / baselinePrice) * 100
    return Math.round(rebatePercent)
  }

  const rebate = calculateRebate()
  return (
    <>
      <div
        style={{
          padding: '20px',
          backgroundColor: '#e6f4ff',
          borderRadius: '8px',
          marginBottom: '20px',
        }}
      >
        <Text
          strong
          style={{ fontSize: '18px', display: 'block', marginBottom: '20px' }}
        >
          {t('received_requests.order_parts_at_price', {
            amount: amount,
            price: basePrice ? (basePrice / 100).toFixed(2) : '0.00',
          })}
        </Text>

        <Row gutter={[24, 16]}>
          <Col span={12}>
            <Form.Item
              label={t('Price per unit')}
              name={[
                orderPartId,
                'provider_offers',
                providerOffer.offer_id,
                'base_price',
              ]}
              initialValue={0}
              rules={[
                {
                  required: false,
                  type: 'number',
                  min: 0,
                  message: t('received_requests.price_required'),
                },
              ]}
            >
              <CustomInputNumber
                mode="currency"
                size="middle"
                addonAfter="€"
                style={{ width: '150px' }}
                precision={2}
                min={0}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            {rebate !== null && rebate !== 0 && (
              <div style={{ marginTop: '30px' }}>
                <Text type="secondary" style={{ fontSize: '14px' }}>
                  {t('received_requests.rebate_info')}:{' '}
                  <span
                    style={{
                      fontWeight: 'bold',
                      color: rebate > 0 ? '#52c41a' : '#ff4d4f',
                    }}
                  >
                    {rebate > 0 ? '-' : '+'}
                    {Math.abs(rebate)}%
                  </span>
                </Text>
              </div>
            )}
          </Col>
        </Row>
      </div>

      <Row style={{ marginTop: 20 }}>
        <Col span="12" style={{ padding: '0 20px 0 0' }}>
          <CustomizeRulesForm
            typeOfRules="price"
            orderPartId={orderPartId}
            providerOffer={providerOffer}
            resetInvalidProviderOffers={resetInvalidProviderOffers}
            deleteRule={deleteRule}
            disabled={true} // Disable price rules for batch mode
          />
        </Col>
        <Col span="12" style={{ padding: '0 0 0 20px' }}>
          <CustomizeRulesForm
            typeOfRules="delivery"
            orderPartId={orderPartId}
            providerOffer={providerOffer}
            resetInvalidProviderOffers={resetInvalidProviderOffers}
            deleteRule={deleteRule}
          />
        </Col>
      </Row>
    </>
  )
}

export default ProviderOfferForm
